import React, { useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { GOOGLE_ICON } from 'images';
import { setIsGoogleSignIn } from 'index/AppActions';
import useGetGoogleSignIn, { BTN_GOOGLE_TEXT } from './hooks/useGetGoogleSignIn';
import Style from './GoogleSignInButton.module.scss';

const GoogleSignInButton = ({
  onClose = () => {},
  toggleCreatePassword = () => {},
  isConsolidatedSignUp = false,
}) => {
  const { dispatch, signIn } = useGetGoogleSignIn(onClose, toggleCreatePassword);

  const handleOnClick = e => {
    e.preventDefault();
    signIn();
  };

  useEffect(
    () => () => {
      dispatch(setIsGoogleSignIn(false));
    },
    [],
  );

  return (
    <button
      className={classNames(Style.googleButton, isConsolidatedSignUp ? Style.circleIcon : null)}
      onClick={handleOnClick}
    >
      <img className={Style.googleButtonIcon} alt="Google Icon" src={GOOGLE_ICON} />
      {!isConsolidatedSignUp && <div className={Style.googleButtonText}>{BTN_GOOGLE_TEXT}</div>}
    </button>
  );
};

GoogleSignInButton.propTypes = {
  isConsolidatedSignUp: PropTypes.bool,
  onClose: PropTypes.func,
  toggleCreatePassword: PropTypes.func,
};

export default GoogleSignInButton;
